import { create } from 'zustand';
import { apiFetch } from '../lib/api';

// 物流定性映射 store（shipping-zones v2「定性配對」前台單一數據源）
// 一次載入 /api/public/shipping/natures-map：{products: {id: code}, categories: {slug: code}}。
// 🇭🇰 badge／海外隱藏／購物車攔截等同步判定全部讀這裡（取代 brandMap 舊靜態清單）。
// 載入前（loaded=false）呼叫端以 brandMap 的 9/4 fallback 清單保守判定——行為不變。

interface NaturesState {
  loaded: boolean;
  categories: Record<string, string>; // category slug → nature code
  products: Record<number, string>;   // product id → nature code（未覆寫者＝類目繼承結果）
  load: () => Promise<void>;
}

export const useNaturesStore = create<NaturesState>((set, get) => ({
  loaded: false,
  categories: {},
  products: {},
  load: async () => {
    if (get().loaded) return;
    try {
      const res = await apiFetch('/api/public/shipping/natures-map');
      const json = await res.json();
      const data = (!Array.isArray(json) && json) || {};
      const map = (data.data as Record<string, Record<string, string>> | undefined) || data;
      set({
        loaded: true,
        categories: map.categories || {},
        products: map.products || {},
      });
    } catch {
      // 失敗＝維持 fallback（badge 沿 9/4 靜態行為）；下次 load 再試
    }
  },
}));
